export var themes = {
  free: 'free',
  grey: 'grey',
  b2b: 'b2b',
  b2c: 'b2c'
};
export var sizes = {
  default: 'default',
  small: 'small'
};
export var TRANSLATIONS = {
  search: {
    en: 'Search',
    ru: 'Поиск'
  }
};